// ================= INTERFACES TỪ API THỰC TẾ =================

export interface ApiCategory {
    id: number;
    name: string;
    isDeleted?: boolean;
    createdAt?: string;
}

export interface ProductQuantity {
    price: string | number;
    quantities?: {
        name: string;
    };
}

export interface Product {
    id: number;
    category_id: number;
    name: string;
    short_description?: string;
    detailed_description?: string;
    image_link?: string;
    isDeleted?: boolean;
    createdAt?: string;
    categories?: {
        name: string;
    };
    product_quantities?: ProductQuantity[];
}

// ================= INTERFACES CHO UI LISTING =================
// Type này được sử dụng khi render danh sách sản phẩm trên frontend
export interface UICategory {
    key: string;  // category_id as string
    label: string; // category name
    unit: string;  // "Sản phẩm"
}

export interface UIProductVariant {
    id: number; // product_quantity_id
    price: number;
    name: string; // Tên dung lượng (ví dụ: "150 gam")
}

export interface UIProduct {
    id: number;
    category: string;
    category_label?: string;
    title: string;
    description: string;
    detailedDescription?: string;
    image: string;
    variants: UIProductVariant[];
}

export interface SelectedItem {
    product: UIProduct;
    variant: UIProductVariant;
    qty: number;
}

// Hàm format giá tiền
export const formatPrice = (p: number | string) => Number(p).toLocaleString("vi-VN") + "₫";



export const AI_MAP: Record<string, number[]> = {
    "thư giãn": [1, 9, 11],
    "chữa lành": [1, 8, 12],
    "ngủ ngon": [1, 9, 13],
    "không gian làm việc": [6, 7, 11],
    "lãng mạn": [5, 8, 13],
    "tươi mát": [4, 7, 11],
};

// Lưu ý: Đã xóa mock data PRODUCTS và CATEGORIES vì bạn đã kết nối API thực tế.

export const SUGGESTION_CHIPS = [
    "Thư giãn", "Chữa lành", "Ngủ ngon",
    "Không gian làm việc", "Lãng mạn", "Tươi mát",
];